// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {map} from 'lodash';
import classnames from 'classnames';

// Components
import Error from '../core/error';
import SelectWithMulti from '../core/select-with-multi';

// Containers
import withSearch from '../../containers/with-search';

function NetworkSelect(props) {
    const {className, error, disabled, fetched, placeholder, searchData, singleSelect, networkId} = props;

    const getClass = () =>
        classnames(
            {
                'network-select': true,
            },
            className
        );

    const getOptions = (networks) =>
        map(networks, (network) => ({
            value: networkId ? network.networkId : network.name,
            label: network.name.split('_').join(' '),
        }));

    const renderSelect = () => {
        let content = null;

        if (!error) {
            content = (
                <SelectWithMulti
                    {...{
                        label: 'Network',
                        name: 'externalNetwork.name||externalNetwork.network.name',
                        noMulti: false,
                        ...props,
                    }}
                    className={getClass()}
                    disabled={disabled && disabled === 'false' ? false : !(fetched || searchData.length)}
                    noMulti={singleSelect}
                    options={getOptions(searchData)}
                    placeholder={placeholder || 'Filter by Network'}
                />
            );
        }

        return content;
    };

    return (
        <div className={getClass()}>
            <Error error={error} />
            {renderSelect()}
        </div>
    );
}

NetworkSelect.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.string,
    error: PropTypes.string,
    fetched: PropTypes.bool.isRequired,
    networkId: PropTypes.bool,
    placeholder: PropTypes.string,
    searchData: PropTypes.array,
    singleSelect: PropTypes.bool,
};

export default withSearch(NetworkSelect, 'networksSelect');
